import React from 'react';

const FAQ = () => (
  <div className="min-h-screen bg-background-main py-12 px-4">
    <div className="max-w-2xl mx-auto">
      <h1 className="text-3xl font-bold mb-8 text-primary-main text-center">Frequently Asked Questions</h1>
    <div className="mb-6">
        <h2 className="text-xl font-semibold mb-2 text-primary-main">What is Hashly?</h2>
        <p className="text-text-secondary">Hashly is an AI-powered tool for generating social media captions and hashtags quickly and easily.</p>
    </div>
    <div className="mb-6">
        <h2 className="text-xl font-semibold mb-2 text-primary-main">How does Hashly work?</h2>
        <p className="text-text-secondary">Hashly uses advanced AI models to analyze your input (mood, niche, or image) and generate creative, engaging captions and relevant hashtags for your social media posts. You simply select your preferences, and Hashly does the rest.</p>
    </div>
    <div className="mb-6">
        <h2 className="text-xl font-semibold mb-2 text-primary-main">Is Hashly free to use?</h2>
        <p className="text-text-secondary">You can try the demo for free. The full app may offer premium features in the future.</p>
    </div>
    <div className="mb-6">
        <h2 className="text-xl font-semibold mb-2 text-primary-main">Do I need to create an account?</h2>
        <p className="text-text-secondary">No account is required to use the free demo. Some features in the full app may require registration.</p>
    </div>
    <div className="mb-6">
        <h2 className="text-xl font-semibold mb-2 text-primary-main">What data does Hashly collect?</h2>
        <p className="text-text-secondary">Hashly does not collect personally identifiable information unless you provide it. For more details, see our Privacy Policy.</p>
    </div>
    <div className="mb-6">
        <h2 className="text-xl font-semibold mb-2 text-primary-main">How is my data used?</h2>
        <p className="text-text-secondary">Any data you provide is used solely to generate captions and improve the service. We do not sell or share your data with third parties except as required for core functionality (see Privacy Policy).</p>
    </div>
    <div className="mb-6">
        <h2 className="text-xl font-semibold mb-2 text-primary-main">Can I use Hashly for business or commercial purposes?</h2>
        <p className="text-text-secondary">Yes! Hashly is designed for both personal and business use. Social media managers, influencers, and brands can all benefit from our AI-powered content generation.</p>
    </div>
    <div className="mb-6">
        <h2 className="text-xl font-semibold mb-2 text-primary-main">What platforms does Hashly support?</h2>
        <p className="text-text-secondary">Hashly generates captions and hashtags suitable for Instagram, Facebook, Twitter, LinkedIn, and more. You can copy and use the content anywhere.</p>
    </div>
    <div className="mb-6">
        <h2 className="text-xl font-semibold mb-2 text-primary-main">How do I contact support?</h2>
        <p className="text-text-secondary">Email us at <a href="mailto:visonovaofficial@gmail.com" className="underline">visonovaofficial@gmail.com</a> for any questions or support needs.</p>
    </div>
    <div className="mb-6">
        <h2 className="text-xl font-semibold mb-2 text-primary-main">How do I delete my data?</h2>
        <p className="text-text-secondary">Click the "Delete account or data" link in the website footer or contact us by email to request data deletion.</p>
    </div>
    <div className="mb-6">
        <h2 className="text-xl font-semibold mb-2 text-primary-main">What should I do if I encounter a problem?</h2>
        <p className="text-text-secondary">If you experience any issues, please refresh the page or try again later. For persistent problems, contact our support team.</p>
    </div>
    <div className="mb-6">
        <h2 className="text-xl font-semibold mb-2 text-primary-main">Is my content private and secure?</h2>
        <p className="text-text-secondary">We take privacy seriously. Your content is processed securely and is not shared with third parties except as described in our Privacy Policy.</p>
    </div>
    <div className="mb-6">
        <h2 className="text-xl font-semibold mb-2 text-primary-main">Can I suggest new features?</h2>
        <p className="text-text-secondary">Absolutely! We welcome feedback and suggestions. Please email us with your ideas.</p>
      </div>
    </div>
  </div>
);

export default FAQ; 